import React, { useEffect, useState } from "react";
import MainContainer from "../components/MainContainer";
import rensImage from "../assets/images/rens.webp";

function AboutPage() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 300);
    return () => clearTimeout(timer);
  }, []);

  return (
    <MainContainer>
      <div
        className={`transition-opacity duration-1000 ${isVisible ? "opacity-100" : "opacity-0"}`}
      >
        <img
          src={rensImage}
          alt='Profile'
          className='w-full h-full object-cover md:hidden mt-10'
        />
        <p className='text-sm'>
          Rens ter Weijde (1984) is an experienced entrepreneur, advisor, and
          board member living in Amsterdam, The Netherlands. Rens studied
          social- and sport psychology (University of Amsterdam), business
          (Harvard Business School), and finance (completing all CFA exams), and
          started working with elite sports teams in soccer, hockey, and extreme
          sports as a psychologist late in his studies. He then began his
          professional career at{" "}
          <a
            href='https://www.mckinsey.com/'
            target='_blank'
            rel='noreferrer'
            className='font-bold'
          >
            McKinsey & Company
          </a>{" "}
          (2011) focused on leadership development and organisational culture.
          <br></br>
          <br></br>Following his time at McKinsey, Rens started{" "}
          <a
            href='https://www.purposeplus.com/services/'
            target='_blank'
            rel='noreferrer'
            className='font-bold'
          >
            his own advisory firm
          </a>{" "}
          which served as a trusted advisor to over 80 clients across industries
          such as software, hardware, space, financial services, advisory,
          fashion, security, utilities, and government (G20). His work for
          clients primarily centred on helping leaders in organisations design
          effective strategies and the corresponding behavioural alignment for
          effective execution. In addition to his advisory work Rens founded and
          led (2019-2023) an AI-company focused on improving education in India
          which partnered with 2,300 local colleges.
          <br></br>
          <br></br>Presently, Rens works as CCO for{" "}
          <a
            href='https://aiaiai.eu/'
            target='_blank'
            rel='noreferrer'
            className='font-bold'
          >
            AIAIAI
          </a>{" "}
          focused on the Agentic AI transformation for SMEs in Europe. In
          addition, he serves on the board of five companies:{" "}
          <a
            href='https://www.sgasecurity.com/'
            target='_blank'
            rel='noreferrer'
            className='font-bold'
          >
            SGA
          </a>
          ,{" "}
          <a
            href='https://www.boomlab.nl/'
            target='_blank'
            rel='noreferrer'
            className='font-bold'
          >
            Boom
          </a>
          ,{" "}
          <a
            href='https://symblemarkets.tech/'
            target='_blank'
            rel='noreferrer'
            className='font-bold'
          >
            Symble
          </a>
          ,{" "}
          <a
            href='https://www.livey.events/'
            target='_blank'
            rel='noreferrer'
            className='font-bold'
          >
            Livey
          </a>
          , and{" "}
          <a
            href='https://bluehealth.co/en/'
            target='_blank'
            rel='noreferrer'
            className='font-bold'
          >
            Blue Health
          </a>
          .
        </p>
      </div>
    </MainContainer>
  );
}

export default AboutPage;
